import { ArrowRightOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Slider } from "antd";
import Countdown from "antd/lib/statistic/Countdown";
import React, { useContext, useEffect, useState } from "react";
import { LayoutContext } from "../../providers/layout";
import PendingOrders from "../pending-orders/pending-orders";
import ShopOrderReport from "../shop-order-report/shop-order-report";
import ShopRequestCount from "../shop-request-count/shop-request-count";
import UserCount from "../user-count/user-count";
import HomeCharts from "./components/home-charts/home-charts";
import "./home.scss";

const marks = {
  0: "off",
  30: "30s",
  60: "60s",
};

const Home: React.FC = () => {
  const { setTitle } = useContext(LayoutContext);

  const [autoReload, setAutoReload] = useState<number>(0);
  const [reloadDeadline, setReloadDeadline] = useState<any>(null);

  const handleAutoReloadChange = (value: any) => {
    setAutoReload(value);
  };

  const handleCountdownFinish = () => {
    setReloadDeadline(autoReload ? Date.now() + autoReload * 1000 : null);
  };

  useEffect(() => {
    setReloadDeadline(autoReload ? Date.now() + autoReload * 1000 : null);
  }, [autoReload]);

  useEffect(() => {
    setTitle("Home");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dashboard-page">
      {/* CHARTS */}
      <div className="dashboard-section">
        <HomeCharts />
      </div>

      {/* STATS */}
      <Row gutter={16} className="dashboard-section">
        <Col md={12} lg={6} xs={24}>
          <Card
            className="dashboard-card"
            title={
              <div className="widget-header">
                <span className="widget-title">Auto Reload</span>
                <div className="widget-actions">
                  {autoReload ? (
                    <Countdown
                      value={reloadDeadline}
                      format="ss"
                      valueStyle={{ fontSize: "14px" }}
                      onFinish={handleCountdownFinish}
                    />
                  ) : (
                    "off"
                  )}
                </div>
              </div>
            }
          >
            <Slider
              marks={marks}
              step={30}
              max={60}
              value={autoReload}
              onChange={handleAutoReloadChange}
            />
          </Card>
        </Col>

        <Col md={12} lg={6} xs={24}>
          <UserCount init autoReload={autoReload} />
        </Col>

        <Col md={12} lg={6} xs={24}>
          <ShopRequestCount init />
        </Col>

        <Col md={12} lg={6} xs={24}>
          <Card className="dashboard-card">
            <div className="widget-header">
              <span className="widget-title">Quick Actions</span>
            </div>

            <div className="quick-actions">
              <Button
                block
                icon={<ArrowRightOutlined />}
                onClick={() => (window.location.href = "/users/new")}
              >
                Add User
              </Button>

              <Button
                block
                icon={<ArrowRightOutlined />}
                onClick={() => (window.location.href = "/orders")}
              >
                View Orders
              </Button>

              <Button
                block
                icon={<ArrowRightOutlined />}
                onClick={() => (window.location.href = "/shop-requests")}
              >
                Shop Requests
              </Button>

              <Button
                block
                icon={<ReloadOutlined />}
                onClick={() => window.location.reload()}
              >
                Refresh Dashboard
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* LISTS */}
      <Row gutter={16}>
        <Col md={12} xs={24}>
          <PendingOrders init />
        </Col>

        <Col md={12} xs={24}>
          <ShopOrderReport init />
        </Col>
      </Row>
    </div>
  );
};

export default Home;
